import "core-js/modules/es.array.push.js";
import vailcode from "@utils/errcode";
import formatter from "@utils/formatter";
export default {
  name: "giftInventory",
  computed: {
    fmt_pre() {
      return formatter.fmt_pre;
    }
  },
  data() {
    return {
      isPageLoading: false,
      tabList: [],
      logs: null,
      logsPage: {
        page: 1,
        total: 0,
        limit: 50,
        finished: false,
        loading: false
      }
    };
  },
  methods: {
    async initFn(item) {
      this.logs = [];
      await this.getLogsListFnc(false);
    },
    getLuckyLogs(params) {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/lucky/lottery/user_gift", {
          page: this.logsPage.page,
          limit: this.logsPage.limit,
          ...params
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          console.log("datadatadatadatadata", data);
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    onGetToTelegram(item) {
      this.$nextTick(() => {
        this.rowTrade = item;
        console.log("this.$refs.popSellGiftRef", this.rowTrade);
        this.$refs.popSellGiftRef.popGetToTelegramShowFnc(true, item);
      });
    },
    onSellPlatform(item) {
      this.$nextTick(() => {
        this.rowTrade = item;
        console.log("this.$refs.popSellGiftRef", this.rowTrade);
        this.$refs.popSellGiftRef.popSellPlatformShowFnc(true, item);
      });
    },
    async popSellGiftFinish(type, item) {
      console.log("itemitemitemitem111115555555", item, this.logs);
      this.logs.forEach((it, idx) => {
        if (it.id == item.id) {
          this.logs.splice(idx, 1, item);
        }
      });
      // await this.getLogsListFnc(false);
    },

    async getLogsListFnc(isPage) {
      this.logsPage.page++;
      if (!isPage) {
        this.logs = [];
        this.logsPage.page = 1;
      }
      const params = {
        page: this.logsPage.page,
        limit: this.logsPage.limit
      };
      this.myRecordIsLoading = true;
      const res = await this.getLuckyLogs(params);
      console.log("resresresresres", res);
      if (!res) return;
      this.logsPage.total = res.total;
      this.logs.push(...res.items);
      this.logsPage.finished = this.logs.length >= this.logsPage.total; // 没有更多数据
      this.logsPage.loading = false;
    },
    async handleScroll() {
      if (this.logsPage.loading || this.logsPage.finished) return;
      // 获取页面滚动的距离
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      // 判断是否接近页面底部（距离底部100px以内时触发加载更多）
      if (scrollTop + windowHeight + 1 >= documentHeight) {
        await this.getLogsListFnc(true);
      }
    }
  },
  async mounted() {
    this.isPageLoading = true;
    await this.initFn();
    this.isPageLoading = false;
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }
};